(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-plz-lang]').forEach(function (root) {
      if (except && root === except) return;
      var btn = root.querySelector('[data-plz-lang-btn]');
      var list = root.querySelector('[data-plz-lang-list]');
      if (!btn || !list) return;
      btn.setAttribute('aria-expanded', 'false');
      list.hidden = true;
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-plz-lang-ready')) return;
    root.setAttribute('data-plz-lang-ready', '1');

    var form = root.querySelector('form');
    var btn = root.querySelector('[data-plz-lang-btn]');
    var list = root.querySelector('[data-plz-lang-list]');
    var input = root.querySelector('[data-plz-lang-input]');
    if (!form || !btn || !list || !input) return;

    function setOpen(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var willOpen = list.hidden;
      closeAll(root);
      setOpen(willOpen);
    });

    list.querySelectorAll('[data-plz-lang-option]').forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var locale = option.getAttribute('data-locale');
        if (!locale || locale === input.value) {
          setOpen(false);
          return;
        }
        input.value = locale;
        form.submit();
      });
    });

    btn.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setOpen(true);
        var first = list.querySelector('[data-plz-lang-option]');
        if (first) first.focus();
      } else if (event.key === 'Escape') {
        setOpen(false);
      }
    });

    list.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        btn.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-plz-lang]').forEach(initRoot);
  }

  document.addEventListener('click', function () {
    closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
